














import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component<OContent>({})
export default class OContent extends Vue {
  @Prop({ default: "" }) type!: string;
  @Prop({ default: "" }) title!: string;
  @Prop({ default: "" }) subtitle!: string;
  @Prop({ default: "" }) text!: string;
}
